<div *ngIf="batchDownloads.length > 0">
  <div class="columns" style="margin-top: 5%; margin-bottom: 0">
    <div class="column is-1"></div>
    <div class="column"
         style="background-color: #336E99; border: 1px solid; border-bottom: none;  border-radius: 10px; color: white">
      <div class="columns">
        <div class="column is-3 has-text-centered">Anfragedatum</div>
        <div class="column is-4 has-text-centered">Name</div>
        <div class="column is-3 has-text-centered">Ablaufdatum</div>
        <div class="column is-2"></div>
        <div class="column"></div>
      </div>
    </div>
    <div class="column is-1"></div>
  </div>

  <div class="columns" style="padding-top: 1rem">
    <div class="column is-1"></div>
    <div class="column">
      <div class="columns card" style="margin: 0; margin-top: 10px" *ngFor="let batchdownload of batchDownloads">
        <div class="column is-3 has-text-centered">
          <p>{{batchdownload.requestDate | date:'dd.MM.yyyy'}}</p>
        </div>
        <div class="column is-4 has-text-centered">
          <p>{{batchdownload.name}}</p>
        </div>
        <div class="column is-3 has-text-centered">
          <p>{{batchdownload.expirationDate | date:'dd.MM.yyyy'}}</p>
        </div>
        <div class="column is-2">
          <a routerLink="/batch-download/{{batchdownload.id}}"
             class="details">Details</a>
        </div>
      </div>
    </div>
    <div class="column is-1"></div>
  </div>
</div>

<div *ngIf="batchDownloads.length < 1">
  <div class="columns" style="padding-top: 3rem">
    <div class="column is-1"></div>
    <div class="column card has-text-centered">
      <p>Aktuell stehen keine Downloads für Sie zur Verfügung.</p>
    </div>
    <div class="column is-1"></div>
  </div>
</div>
